import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import BasePlatForm from "./Platform/index";
import Fl84Platform from "./Fl84Platform/index";
import Game from "./game";
import style from "./index.module.scss";
import PubSub from "pubsub-js";

import counterList from "@/assets/data/countryCodes";
import { rootContext, globalData, isFl84 } from "@/context/rootContext";
import Api from "@/common/Api/bindCreator";
import messageApi from "@/common/Api/message";
import contentApi from "@/common/Api/content";
import { defaultErrorMessage, discordRuleRE, getDomTop, paddingNum } from "@/common/utils";
import { message, Modal, Spin } from "antd";

import Farlight84Error from "@/components/Farlight84Error";
import filterGameData from "@/common/filter/gameDataFilter";
import { applicationData } from "@/assets/data/pageData";

const { confirm } = Modal;
const gameIcons = filterGameData("gameIcons");
const PlatForm = isFl84 ? Fl84Platform : BasePlatForm;
const monthList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

let loadNum = 0;

function Application() {

  const { creatorData, token, setDialogIndex, guideTask, gameList, ableLanguage } = useContext(rootContext);
  const navigate = useNavigate();
  const [type, setType] = useState([]);

  const [game, setGame] = useState([]);

  const [dayList, setDayList] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [chooseYear, setChooseYear] = useState(1900);
  const [chooseMonth, setChooseMonth] = useState(1);
  const [chooseDay, setChooseDay] = useState(1);
  const [chooseCounter, setChooseCounter] = useState("UNITED STATES");
  const [discordAccount, setDiscordAccound] = useState("");
  const [gameUID, setGameUID] = useState("");
  const [gameUserName, setGameUserName] = useState("");
  const [gameUIDCheck, setGameUIDCheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [platformMedia, setPlatformMedia] = useState({});
  const [gameMediaData, setGameMediaData] = useState(null);
  const [platform, setPlatform] = useState([
    { id: 1, name: "youtube", isActive: false, formId: 0, prove: "", isLogin: false },
    { id: 2, name: "tiktok", isActive: false, formId: 0, prove: "", isLogin: false },
    { id: 3, name: "twitch", isActive: false, formId: 0, prove: "", isLogin: false }
  ]);

  const platformRef = useRef();
  const createRef = useRef();
  const gameRef = useRef();
  const userRef = useRef();
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const langRef = useRef();

  useEffect(() => {
    const yearList = [];
    const dayList = [];
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const dayMax = new Date(year, month, 0).getDate();
    for (let i = 1900; i <= year; i++) {
      yearList.push(i);
    }
    for (let i = 1; i <= dayMax; i++) {
      dayList.push(i);
    }
    setYearList(yearList);
    setDayList(dayList);
    setChooseYear(year - 19);
    setChooseMonth(month);
    setChooseDay(day);

    const applicationGame = gameList.map((item, index) => {
      return {
        id: index,
        name: item.tag,
        isActive: false,
        icon: gameIcons[item.tag] || item.icon
      };
    });
    if (applicationGame.length === 1) {
      applicationGame[0].isActive = true;
    }
    setGame(applicationGame);

    // setChooseCounter(window.localStorage.getItem("lilacRegion"));
    const locationRegion = window.localStorage.getItem("lilacRegion");
    if (locationRegion && creatorData && !creatorData.region) {
      for (let i = 0; i < counterList.code.length; i++) {
        if (locationRegion === counterList.code[i]) {
          setChooseCounter(counterList.country[i]);
          break;
        }
      }
    }

    if (creatorData) {
      setDiscordAccound(creatorData.discord || "");
      if (creatorData.region) {
        setChooseCounter(creatorData.region);
      }
      if (creatorData.birthday) {
        const t = new Date(creatorData.birthday);
        setChooseYear(t.getFullYear() || year - 19);
        setChooseMonth(t.getMonth() + 1);
        setChooseDay(t.getDate() || day);
      }
      if (creatorData.games && creatorData.games.length) {
        const gameList = [...game];
        for (const item of gameList) {
          if (item.name === creatorData.games[0].tag) {
            item.isActive = true;
            setGame(gameList);
            break;
          }
        }
        setGameUserName(creatorData.games[0].partName);
        setGameUID(creatorData.games[0].uid);
      }
      if (creatorData.realInfo && creatorData.realInfo.length) {
        firstNameRef.current.value = creatorData.realInfo[0].realName.split(" ")[0];
        lastNameRef.current.value = creatorData.realInfo[0].realName.split(" ")[1];
      }
    }

    getPosList();
  }, [creatorData]);

  const getPosList = async () => {
    const res = await messageApi.getActivePosList();
    if (res.status === 200) {
      const typeList = res.data.map(item => {
        return {
          ...item,
          isActive: false
        };
      });
      if (creatorData && creatorData.games && creatorData.games.length) {
        const createTypeList = creatorData.games[0].activePoz.map((item) => item.activePos);
        const newTypeList = [...typeList];
        for (const item of newTypeList) {
          if (createTypeList.includes(item.value)) {
            item.isActive = true;
          }
        }
        setType(newTypeList);
      } else {
        setType(typeList);
      }
    }
  };

  const checkRealName = () => {
    const firstName = firstNameRef.current.value.trim();
    const lastName = lastNameRef.current.value.trim();
    const nameReg = new RegExp("[^a-zA-Z]");
    return firstName && !nameReg.test(firstName) && lastName && !nameReg.test(lastName);
  };

  const checkVideoBelong = async (data) => {
    const res = await contentApi.checkVideoBelong(globalData.activeGameData.tag, data);
    if (res.status === 200) {
      if (res.data.isOwn) { return true; }
      else {
        return false;
      }
    } else {
      Modal.error({
        title: "ERROR",
        content: res.data.message,
      });
      return false;
    }
  };

  const checkData = async () => {
    const gameIndex = game.filter(item => item.isActive)[0];
    const sendData = {
      birthday: `${chooseYear}-${paddingNum(chooseMonth, 2)}-${paddingNum(chooseDay, 2)}`,
      region: chooseCounter,
      discord: discordAccount.trim(),
      game: {
        tag: gameIndex ? gameIndex.name : "",
        uid: gameUID.trim(),
        partName: gameUserName.trim() || null,
        activePoz: type.map(item => item.isActive ? { activePos: item.value } : "").filter(item => item)
      },
      mInfos: [],
      realInfo: {
        realName: [firstNameRef.current.value.trim(), lastNameRef.current.value.trim()].join(" "),
        country: chooseCounter
      }
    };
    if (ableLanguage.length > 1) {
      sendData.language = langRef.current.value;
      // console.log(sendData.language);
    }

    const mediaData = await getMediaUseData(platform);
    if (mediaData.length) {
      for (const item of mediaData) {
        if (item) {
          if (item.nickName) {
            const data = {
              tag: item.tag || "",
              nickName: item.nickName || "",
              followers: item.followers || 0,
              videoCount: item.videoCount || 0,
              prove: item.prove,
              uid: item.uid,
              channelUrl: item.channelUrl
            };
            if (isFl84) {
              if (!platformMedia[item.tag]) {
                document.documentElement.scrollTo(0, document.documentElement.clientHeight / 2);
                message.error("Please upload 1 video related to Farlight 84");
                setLoading(false);
                return;
              }
              if (platformMedia[item.tag].errFlag) {
                document.documentElement.scrollTo(0, getDomTop(platformRef.current) + 30);
                farlight84Error();
                setLoading(false);
                return;
              }
              data.contentUrl = platformMedia[item.tag].contentUrl;
              // if (item.tag === "tiktok") {
              //   data.accessToken = platformMedia[item.tag].accessToken;
              // }
              const checkData = item.tag === "tiktok" ? {
                // tiktokToken: bindMediaData.accessToken,
                homePageUrl: data.channelUrl,
                contentUrl: data.contentUrl
              } : {
                uid: data.uid,
                contentUrl: data.contentUrl
              };
              const isBelone = await checkVideoBelong(checkData);
              if (!isBelone) {
                document.documentElement.scrollTo(0, document.documentElement.clientHeight / 2);
                message.error("Please upload your own video works");
                setLoading(false);
                return;
              }
            }
            sendData.mInfos.push(data);
          } else if (loadNum > 5) {
            loadNum = 0;
            defaultErrorMessage({}, "mediaData");
            setLoading(false);
            return;
          } else {
            loadNum++;
            setLoading(true);
            setTimeout(() => { checkData(); }, 2000);
            return;
          }
        }
      }
    } else {
      document.documentElement.scrollTo(0, getDomTop(platformRef.current) + 30);
      message.error("Bind at least one social media account and upload a dashboard screenshot.");
      setLoading(false);
      return;
    }

    if (!sendData.mInfos.length) {
      document.documentElement.scrollTo(0, getDomTop(platformRef.current) + 30);
      message.error("Bind at least one social media account and upload a dashboard screenshot.");
      setLoading(false);
      return;
    } else {
      for (const item of sendData.mInfos) {
        if (!item.prove) {
          for (const subItem of platform) {
            if (subItem.name === item.tag) {
              subItem.isActive = true;
            } else {
              subItem.isActive = false;
            }
          }
          setPlatform([...platform]);
          document.documentElement.scrollTo(0, getDomTop(platformRef.current));
          message.error("Bind at least one social media account and upload a dashboard screenshot.");
          setLoading(false);
          return;
        }
      }
    }
    if (!sendData.game.activePoz.length) {
      document.documentElement.scrollTo(0, getDomTop(createRef.current) + 30);
      setLoading(false);
      message.error("Choose at least 1 content direction.");
      return false;
    }
    const gameCheck = await checkGameData(sendData);
    if (!gameCheck) {
      document.documentElement.scrollTo(0, getDomTop(gameRef.current));
      setLoading(false);
      return;
    }
    if (!checkRealName()) {
      document.documentElement.scrollTo(0, getDomTop(firstNameRef.current) - 300);
      message.error("The real name is not in the correct format");
      setLoading(false);
    } else if (!sendData.discord) {
      document.documentElement.scrollTo(0, getDomTop(userRef.current));
      setLoading(false);
      message.error("Please enter your Discord ID");
    } else if(!discordRuleRE.test(sendData.discord)) {
      document.documentElement.scrollTo(0, getDomTop(userRef.current));
      setLoading(false);
      message.error("Discord UID must be 18 or 19 digits. Please try again. ");
    } else {
      checkMultipleRegister(sendData);
      // submit(sendData);
    }
  };

  const checkGameData = async (sendData) => {
    if (!isFl84 && sendData.game.tag === "farlight84") {
      if (!gameMediaData) {
        message.error("Please upload 1 video related to Farlight 84");
        return false;
      }
      if (gameMediaData.errFlag) {
        farlight84Error();
        return false;
      }
      for (const item of sendData.mInfos) {
        if (item.tag === gameMediaData.mTag) {
          item.contentUrl = gameMediaData.contentUrl;
          // if (item.tag === "tiktok") {
          //   item.accessToken = gameMediaData.accessToken;
          // }

          const checkData = item.tag === "tiktok" ? {
            // tiktokToken: item.accessToken,
            homePageUrl: item.channelUrl,
            contentUrl: gameMediaData.contentUrl
          } : {
            uid: item.uid,
            contentUrl: gameMediaData.contentUrl
          };
          setLoading(true);
          const isBelone = await checkVideoBelong(checkData);
          setLoading(false);
          if (!isBelone) {
            message.error("Please upload your own video works");
            return false;
          }
          
          break;
        }
      }
    }
    if (sendData.game.tag !== "farlight84") {
      if (!sendData.game.tag || !sendData.game.uid || !sendData.game.partName) {
        message.error("Choose at least 1 game tag and correctly enter your in-game UID and username.");
        return false;
      }
    } else {
      // fl84
      if (!sendData.game.uid || !gameUIDCheck) {
        message.error("Choose at least 1 game tag and correctly enter your in-game UID and verificaion your UID.");
        return false;
      }
    }
    return true;
  };

  const finishTask = () => {
    if (!guideTask[4].done) {
      messageApi.finishTask({ token, id: guideTask[4].taskId });
    }
    if (!guideTask[5].done) {
      messageApi.finishTask({ token, id: guideTask[5].taskId });
    }
  };

  const checkMultipleRegister = async (data) => {
    const checkData = {
      loginName: creatorData.loginName,
      email: creatorData.email,
      regionConfigId: +globalData.regionConfigId,
      games: [
        {
          uid: data.game.uid,
          tag: data.game.tag
        }
      ],
      mInfos: data.mInfos.map(item => ({
        tag: item.tag,
        uid: item.uid
      }))
    };
    setLoading(true);
    const res = await Api.multipleRegister(checkData);
    setLoading(false);
    if (res.data && res.data.statusCode === 400) {
      // 已在其他区注册
      confirm({
        title: "Tip",
        content: "You have already registered as a creator in another region. Do you continue to submit your application to become a creator?",
        okText: "NO",
        cancelText: "YES",
        onOk() {
        },
        onCancel() {
          submit(data);
        },
      });
      setTimeout(() => {
        const tipElement = document.createElement("p");
        tipElement.innerHTML = "If you have any questions, please contact us through the creator discord server of the related game.";
        document.getElementsByClassName("ant-modal-confirm-btns")[0].appendChild(tipElement);
      }, 100);
      return;
    }
    // console.log(data);

    submit(data);
  };

  const submit = async (data) => {
    // console.log(data);
    const header = {
      token: token,
      gametag: data.game.tag
    };
    setLoading(true);
    const res = await Api.applyToCreator(data, header);
    window.gtag("event", "m_application_submit");
    setLoading(false);
    // console.log(res);
    if (res.status === 200) {
      finishTask();
      if (isFl84) {
        setLoading(true);
        window.gtag("event", "m_fl84_application");
        setDialogIndex(20);
        return;
      }
      setDialogIndex(5);
      navigate("/");
    } else {
      Modal.error({
        title: "ERROR",
        content: res.data.message,
      });
    }
  };

  const getMediaUseData = async (platform) => {
    const platFormData = [];
    for (const item of platform) {
      if (item.isLogin) {
        const res = await Api.getBindMediaData({
          formId: item.formId
        });
        if (res && res.status === 200) {
          const bindMediaData = {
            tag: item.name.toLowerCase(),
            nickName: "",
            followers: 0,
            prove: item.prove,
            ...res.data
          };
          platFormData.push(bindMediaData);
          item.bindMediaData = bindMediaData;
        } else {
          item.isLogin = false;
          setPlatform([...platform]);
          getMediaUserDataError();
          return [];
        }
      }
    }
    if (platFormData.length > 0) {
      setPlatform([...platform]);
    }
    return platFormData;
  };

  const getMediaUserDataError = () => {
    Modal.error({
      title: "ERROR",
      content: "Failed to authorize account binding. Please try again."
    });
    document.documentElement.scrollTo(0, getDomTop(platformRef.current) + 30);
  };

  const clickType = (type, index) => {
    type[index].isActive = !type[index].isActive;
    setType([...type]);
  };

  const changeYear = (e) => {
    const year = e.target.value;
    const indexTime = new Date(year, chooseMonth, 0).getDate();
    const Day = indexTime >= chooseDay ? chooseDay : 1;
    if (isOverEighteen(new Date(`${year}/${chooseMonth}/${Day}`))) {
      setChooseYear(year);
      setChooseDay(Day);
      reSetDayList(year, chooseMonth);
    } else {
      message.info("The creator must be at least 18 years old");
    }
  };

  const changeMonth = (e) => {
    const month = e.target.value;
    const indexTime = new Date(chooseYear, month, 0).getDate();
    const Day = indexTime >= chooseDay ? chooseDay : 1;
    if (isOverEighteen(new Date(`${chooseYear}/${month}/${Day}`))) {
      setChooseMonth(month);
      setChooseDay(Day);
      reSetDayList(chooseYear, month);
    } else {
      message.info("The creator must be at least 18 years old");
    }
  };

  const changeDay = (e) => {
    const Day = e.target.value;
    if (isOverEighteen(new Date(`${chooseYear}/${chooseMonth}/${Day}`))) {
      setChooseDay(e.target.value);
    } else {
      message.info("The creator must be at least 18 years old");
    }
  };

  const isOverEighteen = (birthday) => {
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs);
    var age = Math.abs(ageDate.getUTCFullYear() - 1970);
    if (age > 17) {
      return true;
    } else {
      return false;
    }
  };

  const reSetDayList = (year, month) => {
    const datMax = new Date(year, month, 0).getDate();
    const dayList = [];
    for (let i = 1; i <= datMax; i++) {
      dayList.push(i);
    }
    setDayList(dayList);
  };

  const logout = () => {
    PubSub.publish("logout", null);
  };

  const checkLogin = async (platform, setPlatform) => {
    const uploginLeng = platform.filter(item => !item.isLogin && item.formId).length;
    for (const item of platform) {
      if (!item.isLogin && item.formId) {
        const res = await Api.getBindMediaData({ formId: item.formId, token: token });
        if (res && res.status === 200 && res.data.nickName) {
          // console.log(item.tag);
          item.isLogin = true;
        }
      }
    }
    const newLeng = platform.filter(item => !item.isLogin && item.formId).length;
    if (uploginLeng !== newLeng) {
      setPlatform([...platform]);
    } else if (newLeng) {
      setTimeout(() => { checkLogin(platform, setPlatform); }, 2000);
    }
  };

  const farlight84Error = () => {
    Modal.error({
      getContainer: "#application_box",
      title: "Error",
      content: (
        <Farlight84Error />
      ),
    });
  };

  useEffect(() => {
    // console.log(platform.filter(item => !item.isLogin && item.formId));
    if (platform.filter(item => !item.isLogin && item.formId).length) {
      setTimeout(() => { checkLogin(platform, setPlatform); }, 5000);
    }
  }, [platform]);

  const enterDiscord = (value) => {
    setDiscordAccound(value.replace(/\D/g, ""));
  };

  return (
    <section>
      <div className={style.application_box} id="application_box">
        <div className={style.logout} onClick={logout}></div>
        <p className={style.title1}>{ applicationData.applicationTitle }</p>
        <p className={style.user_account}>{ applicationData.welcome } <span>{creatorData ? creatorData.loginName : ""}</span></p>
        <p className={style.application_detail} ref={platformRef}>
          { applicationData.applicationDesc.map(item => <>{item}&nbsp;</>) }
        </p>
        {/* 社交平台 */}
        <PlatForm platform={platform} setPlatform={setPlatform} setPlatformMedia={setPlatformMedia} />
        {/* 创作类型 */}
        <div className={style.create_type} ref={createRef}>
          <p className={style.module_title}>{ applicationData.createTypeTitle }</p>
          <p className={style.module_desc} dangerouslySetInnerHTML={{__html: applicationData.createTypeDesc}} ></p>
          <ul>
            {
              type.map((item, index) => {
                return (
                  <li key={item.id} className={`${item.isActive ? style.active : ""}`} onClick={() => clickType(type, index)}>
                    {item.name}
                  </li>
                );
              })
            }
          </ul>
        </div>
        {/* 游戏类型 */}
        <div className={style.game_type} ref={gameRef}>
          <Game
            game={game}
            platform={platform}
            setGame={setGame}
            setGameUID={setGameUID}
            setGameUserName={setGameUserName}
            saveGameMedia={setGameMediaData}
            setGameUIDCheck={setGameUIDCheck}
          />
        </div>
        {/* 用户数据 */}
        <div className={style.user_data}>
          <p className={style.module_title}>{ applicationData.userDetailTitle }</p><br />
          <p className={style.module_desc}>{ applicationData.userDetailSubTitle1 }</p>
          <p className={style.module_desc}>{ applicationData.userDetailSubDesc1 }</p>
          <ul className={style.user_detail}>
            <li>
              <p>{ applicationData.day }</p>
              <select value={chooseDay} onChange={(e) => changeDay(e)}>
                {
                  dayList.map((item) => {
                    return (
                      isOverEighteen(new Date(`${chooseYear}/${chooseMonth}/${item}`)) ? (
                        <option key={item} value={item} >{item}</option>
                      ) : (
                        <option key={item} value={item} disabled>{item}</option>
                      )
                    );
                  })
                }
              </select>
            </li>
            <li>
              <p>{ applicationData.month }</p>
              <select value={chooseMonth} onChange={(e) => changeMonth(e)}>
                {
                  monthList.map((item) => {
                    return (
                      isOverEighteen(new Date(`${chooseYear}/${item}/${chooseDay}`)) ? (
                        <option key={item} value={item} >{item}</option>
                      ) : (
                        <option key={item} value={item} disabled>{item}</option>
                      )
                    );
                  })
                }
              </select>
            </li>
            <li>
              <p>{ applicationData.year }</p>
              <select value={chooseYear} onChange={(e) => changeYear(e)}>
                {
                  yearList.map((item) => {
                    return (
                      isOverEighteen(new Date(`${item}/${chooseMonth}/${chooseDay}`)) ? (
                        <option key={item} value={item} >{item}</option>
                      ) : (
                        <option key={item} value={item} disabled>{item}</option>
                      )
                    );
                  })
                }
              </select>
            </li>
          </ul>
          <ul>
            <p className={style.module_desc}>&nbsp;</p>
            <p className={style.module_desc}>{ applicationData.userDetailSubTitle2 }</p>
            <div className={style.real_box}>
              <div>
                <p>{ applicationData.firstName }</p>
                <input ref={firstNameRef}></input>
              </div>
              <div>
                <p>{ applicationData.laseName }</p>
                <input ref={lastNameRef}></input>
              </div>
            </div>
          </ul>
          {
            ableLanguage.length > 1 && (
              <ul className={style.language}>
                <p>{ applicationData.userDetailSubTitle3 }</p>
                <li>
                  <select ref={langRef}>
                    {
                      ableLanguage.map((item, index) => {
                        return (
                          <option key={index} value={item.code} >{item.language}</option>
                        );
                      })
                    }
                  </select>
                </li>
              </ul>
            )
          }
          <ul className={style.country} ref={userRef}>
            <p>{ applicationData.userDetailSubTitle4 }</p>
            <li>
              <select value={chooseCounter} onChange={(e) => { setChooseCounter(e.target.value); }}>
                {
                  counterList.country.map((item, index) => {
                    return (
                      <option key={index} value={item} >{item}</option>
                    );
                  })
                }
              </select>
            </li>
          </ul>
          <div className={style.discord}>
            <p className={style.module_title}>{filterGameData("commitTitle") || applicationData.discordTitle}</p>
            <p className={style.module_desc}>{filterGameData("commitDesc") || applicationData.discordDesc}</p>
            <input
              value={discordAccount}
              className={discordRuleRE.test(discordAccount) ? "" : style.error}
              onChange={(e) => { enterDiscord(e.target.value); }}
              maxLength={19}
            ></input>
            <i className={style.tip} onClick={() => { setDialogIndex(26); }}>?</i>
          </div>
          <div className={`${style.submit} ${isFl84 ? style.fl84 : ""}`} onClick={checkData}>
            { applicationData.submitBtn }
          </div>
        </div>
      </div>
      {
        loading && (
          <div className={style.mask}>
            <Spin size="large" />
          </div>
        )
      }
    </section>
  );
}

export default Application;
